<bp-universal-error-page class="reddish">
	<h1>Oops, something has gone wrong.</h1>
	<p>Please check your connection and try again later or contact support if the problem persists</p>
</bp-universal-error-page>
